import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';


export const getServiceShopStorageLocation = createAsyncThunk('/GetServiceShopStorageLocation', 
    async (Type) => {
        const response = await axios.get(`/GetServiceShopStorageLocation/${Type}`);
        return response.data;
});

export const setStorageLocationManagement  = createAsyncThunk('/SetStorageLocationManagement', 
    async (data) => {
        const response = await axios.post(`/SetStorageLocationManagement`, data);
        return response.data;
});

export const setServiceShopStorageLocationManagement  = createAsyncThunk('/SetServiceShopStorageLocationManagement', 
    async (data) => {
        const response = await axios.post(`/SetServiceShopStorageLocationManagement`, data);
        return response.data;
});

export const getStorageLocation = createAsyncThunk('/GetStorageLocation',
    async() => {
        const response = await axios.get('GetStorageLocation');
        return response.data;
});

export const getRegionForServiceShop = createAsyncThunk('/getRegionForServiceShop', 
    async () => {
      const response = await axios.get('/GetRegionForServiceShop');
      return response.data;
});

const storageLocationSlice = createSlice({
    name: 'storageLocation',
    initialState: {
      loading: false,
      error: '',
      StorageLocations: [],
      StorageLocationManagement:[],
      ServiceShopStorageLocationManagement:[],
      storageData:[],
      serviceShop:[]
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
          .addCase(getServiceShopStorageLocation.pending, (state) => {
            state.loading = true;
          })
          .addCase(getServiceShopStorageLocation.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(getServiceShopStorageLocation.fulfilled, (state, action) => {
            state.StorageLocations = action.payload;
            state.loading = false;
          })
          .addCase(setStorageLocationManagement.pending, (state) => {
            state.loading = true;
          })
          .addCase(setStorageLocationManagement.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(setStorageLocationManagement.fulfilled, (state, action) => {
            state.StorageLocationManagement = action.payload;
            state.loading = false;
          })
          .addCase(setServiceShopStorageLocationManagement.pending, (state) => {
            state.loading = true;
          })
          .addCase(setServiceShopStorageLocationManagement.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(setServiceShopStorageLocationManagement.fulfilled, (state, action) => {
            state.ServiceShopStorageLocationManagement = action.payload;
            state.loading = false;
          })
          .addCase(getStorageLocation.pending, (state) => {
            state.loading = true;
          })
          .addCase(getStorageLocation.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(getStorageLocation.fulfilled, (state, action) => {
            state.storageData = action.payload;
            state.loading = false;
          })
          .addCase(getRegionForServiceShop.pending, (state) => {
            state.loading = true;
          })
          .addCase(getRegionForServiceShop.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(getRegionForServiceShop.fulfilled, (state, action) => {
            state.serviceShop = action.payload;
            state.loading = false;
          });
    }
});

export const storageLocationActions = storageLocationSlice.actions;
export default storageLocationActions;